/* eslint rxjs/no-nested-subscribe: "warn"
--------
TODO: refactor and cleanup these nested subscribes.
DON'T COPY THIS WARN OVERRIDE TO NEW FILES;
IT'S ONLY HERE TO ALLOW TIME FOR FIXES IN EXISTING FILES
*/
import { Component, Injector, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { forkJoin, Observable, of } from 'rxjs';
import { finalize } from 'rxjs/operators';
import {
  ApAlertService,
  ApBaseModalComponent,
  ApDatePickerValue,
  ApFileUploadService,
} from 'webcommon/core-ui';
import { ApFindControlService } from 'webcommon/find-control';
import { ApHtmlTextEditorComponent } from 'webcommon/html-editor';
import { FindControlIdService } from 'webcommon/legacy-common';
import {
  CreateFacilityPortalMessageDto,
  FacilityPatientDetailsDto,
  FindControlAdditionalSearchParametersDto,
  FindControlAdditionalSearchParametersType,
  FindControlMessageSubType,
  FindControlSearchParameterItemDto,
  FpAttachmentDto,
  FpMessageCreatedDto,
  FpUserPropertiesDto,
  IColumnPk,
  SystemGuid,
} from 'webcommon/shared';
import { FpMessagesRepository, FpPatientRepository } from 'webcommon/webapi';
import { FpConfigurationService } from '../services/index';

@Component({
  providers: [ApAlertService],
  selector: 'fp-message-create-modal',
  styleUrls: ['./fp-message-create-modal.component.less'],
  templateUrl: './fp-message-create-modal.component.html',
})
export class FPMessageCreateModalComponent extends ApBaseModalComponent<FpMessageCreatedDto | null> implements OnInit {
  constructor(
    public findControlIdService: FindControlIdService,
    private systemGuid: SystemGuid,
    private fpPatientRepository: FpPatientRepository,
    private fpMessagesRepository: FpMessagesRepository,
    private apFileUploadService: ApFileUploadService,
    private fpConfigurationService: FpConfigurationService,
    private apAlertService: ApAlertService,
    private apFindControlService: ApFindControlService,
    elementInjector: Injector,
  ) {
    super(elementInjector);
  }

  @ViewChild('createMessageForm', { static: true }) createMessageForm: NgForm;
  @ViewChild('apHtmlTextEditor') apHtmlTextEditor: ApHtmlTextEditorComponent;

  // initialState params
  baseId: string | null;
  fromUserName: string | null;
  messageDefaultUrgencyId: string;
  messageTypeId: string;
  messageTypeName: string;
  messageSubTypeId: string;
  messageSubTypeName: string;
  userProperties: FpUserPropertiesDto | null;

  Id: string;

  attachments: File[] = [];
  practiceProvider = '';
  messageSubject = '';
  messageBody = '';
  dueDate: ApDatePickerValue = undefined;
  selectedToUserAndUserGroupIds: string[] = [];
  messageUrgencySelected: string[] = [];
  selectedFpPatientIds: any[] = [];
  selectedServiceSiteIds: string[] = [];
  selectedPatientProgramIds: string[] = [];
  subtypeSelected: string[] = [];
  subtypeDisabled = false;
  modalLoading = false;
  sendingMessage = false;
  hasError = false;
  subjectRequired = true;
  subjectDisabled = false;
  errorMessage = '';
  allowedExtensions = '';
  fileSizeLimit: number | null = null;
  maxFiles: number | null = null;

  attachmentsRequired = false;

  subtypeAdditionSearchParameters: FindControlAdditionalSearchParametersDto | undefined;
  patientFindControlAdditionalSearchParams: FindControlAdditionalSearchParametersDto | undefined;
  assignToAdditionalSearchParams: FindControlAdditionalSearchParametersDto | undefined;

  inputNames = {
    duedate: 'duedate',
    practiceprovider: 'practiceprovider',
    subject: 'subject',
  };

  override ngOnInit() {
    super.ngOnInit();
    this.loading = true;

    this.setId();
    this.load();
  }

  private load() {
    this.subtypeAdditionSearchParameters = {
      Type: FindControlAdditionalSearchParametersType.Standard,
      AdditionalSearchParameters: [
        {
          ColumnName: 'MessageTypeUid',
          Value: this.systemGuid.FacilityPortalMessageType,
        },
      ],
    };
    this.patientFindControlAdditionalSearchParams = {
      Type: FindControlAdditionalSearchParametersType.MultipleValues,
      AdditionalSearchParameters:
      [],
    };
    this.assignToAdditionalSearchParams = {
      Type: FindControlAdditionalSearchParametersType.Standard,
      AdditionalSearchParameters:
      [
        {
          ColumnName: 'UserGroupType',
          Value: this.messageSubTypeId ===  this.systemGuid.AttachmentSubMessageType ? 'User' : '',
        },
      ],
    };

    if (this.userProperties) {
      if (this.userProperties.PatientProgramsForFacilityPortalUser) {
        for (const e of this.userProperties.PatientProgramsForFacilityPortalUser) {
          const searchParameterItem: FindControlSearchParameterItemDto = {
            ColumnName: 'PatientProgramUid',
            Value: e.Uid,
          };
          this.patientFindControlAdditionalSearchParams.AdditionalSearchParameters.push(searchParameterItem);
        }
      }

      if (this.userProperties.ServiceSitesForFacilityPortalUser) {
        for (const e of this.userProperties.ServiceSitesForFacilityPortalUser) {
          const searchParameterItem: FindControlSearchParameterItemDto = {
            ColumnName: 'ServiceSiteUid',
            Value: e.Uid,
          };
          this.patientFindControlAdditionalSearchParams.AdditionalSearchParameters.push(searchParameterItem);
        }
      }
    }

    this.subtypeSelected.push(this.messageSubTypeId);

    if (this.messageDefaultUrgencyId && this.messageDefaultUrgencyId !== this.systemGuid.GuidEmpty) {
      this.messageUrgencySelected.push(this.messageDefaultUrgencyId);
    }

    if (this.messageSubTypeId === this.systemGuid.AttachmentSubMessageType) {
      this.attachmentTypeSelected();
    }

    this.fileSizeLimit = this.fpConfigurationService.getAttachmentSizeLimit();
    this.allowedExtensions = this.fpConfigurationService.getAllowedAttachmentExtensions();
    this.maxFiles = this.fpConfigurationService.getMaxFiles();

    this.loading = false;
  }

  private setId() {
    this.Id = `${this.baseId}-create-modal`;
  }

  public cancel() {
    super.dismissModal(null);
  }

  public send() {
    if (this.createMessageForm && !this.createMessageForm.valid) {
      return;
    }

    const attachmentsResultsDto: Observable<FpAttachmentDto[]> = this.convertFilesToDto(this.attachments);
    const content = this.apHtmlTextEditor.getContent();
    attachmentsResultsDto.subscribe((attachments) => {
      this.sendingMessage = true;
      const createMessageRequest: CreateFacilityPortalMessageDto = {
        Attachments: attachments,
        Body: content,
        DueDate: this.dueDate || null,
        MessageSubTypeId: this.subtypeSelected[0],
        PatientId: this.selectedFpPatientIds[0],
        Subject: this.messageSubject,
        ToUserAndUserGroupIds: this.selectedToUserAndUserGroupIds,
        UrgencyId: this.messageUrgencySelected[0],
      };
      this.fpMessagesRepository.postMessage(createMessageRequest)
        .pipe(finalize(() => {
          this.sendingMessage = false;
        }),
        ).subscribe((result: FpMessageCreatedDto) => {
          super.closeModal(result);
          },
          () => {
            this.hasError = true;
          },
        );
    }, () => {
      this.hasError = true;
      return;
    });
  }

  updatePracticeProvider(value: string): void {
    const control = this.createMessageForm.controls[this.inputNames.practiceprovider];
    control.setValue(value);
    control.markAsDirty();
  }

  updateMessageSubject(value: string): void {
    const control = this.createMessageForm.controls[this.inputNames.subject];
    control.setValue(value);
    control.markAsDirty();
  }

  getReadOnlyFields(ids: any[]): void {
    if (ids.length) {
      this.modalLoading = true;
      this.fpPatientRepository.getFacilityPatientDetails(ids[0].PersonUid)
      .pipe(finalize(() => {
        this.modalLoading = false;
      }),
      ).subscribe((data: FacilityPatientDetailsDto) => {
          if (data.ServiceSite && data.ServiceSite.Id) {
            this.selectedServiceSiteIds = [data.ServiceSite.Id];
          } else {
            this.selectedServiceSiteIds = [];
          }

          if (data.Provider && data.Provider.FullName) {
            this.practiceProvider = data.Provider.FullName;
          } else {
            this.practiceProvider = '';
          }

          if (data.PatientPrograms && data.PatientPrograms.length > 0) {
            this.selectedPatientProgramIds = data.PatientPrograms.map(x => x.Id);
          } else {
            this.selectedPatientProgramIds = [];
          }
        },
        () => {
          this.hasError = true;
        },
      );
    } else {
      this.selectedServiceSiteIds = [];
      this.practiceProvider = '';
      this.selectedPatientProgramIds = [];
    }
  }

  convertFilesToDto(files: File[]): Observable<FpAttachmentDto[]> {
    if (files && files.length > 0) {
      const convert = files.map((file) => this.apFileUploadService.convertToByteArray(file));
      return forkJoin(convert);
    }

    return of([]);
  }

  filesChanged(files: File[]) {
    this.subtypeSelected = [this.systemGuid.AttachmentSubMessageType];
    this.attachments = files;

    this.attachmentTypeSelected();
  }

  attachmentTypeSelected() {
    this.messageSubject = '';
    this.subtypeDisabled = true;
    this.attachmentsRequired = true;
  }

  public subtypeChanged(subtype: IColumnPk[]): void {
    this.attachmentsRequired = false;
    if (subtype && subtype.length) {
      const selectedSubType = this.apFindControlService.mapFindControlObject<FindControlMessageSubType>(subtype[0]);
      if (selectedSubType) {
        this.messageSubTypeName = selectedSubType.Name;
        if (selectedSubType.MessageSubTypeUid === this.systemGuid.AttachmentSubMessageType) {
          this.attachmentTypeSelected();
        }
      }
    }
  }

  getSubjectRequired() {
    if (this.subtypeSelected[0] === this.systemGuid.AttachmentSubMessageType) {
      return false;
    }

    return true;
  }

  getSubjectDisabled() {
    if (this.subtypeSelected[0] === this.systemGuid.AttachmentSubMessageType) {
      return true;
    }

    return false;
  }

  displayError(event: string) {
    if (event) {
      this.apAlertService.clearAllAlerts();
      this.apAlertService.error(event);
    } else {
      this.apAlertService.clearAllAlerts();
    }
  }
}
